export default "__VITE_ASSET__BKNueBSW__"